export enum OldEngagementStatusEnum {
	New = 'New',
	InProgress = 'In progress',
	Confirmed = 'Confirmed',
	Completed = 'Completed',
	Incomplete = 'Incomplete',
}

export enum EngagementStatusEnum {
	New = '682416ac476055a61191fafe',
	InProgress = '682416ac476055a61191faff',
	Confirmed = '682416ac476055a61191fb00',
	Completed = '682416ac476055a61191fb01',
	Incomplete = '682416ac476055a61191fb02',
}

export const EngagementStatusArray = [
	EngagementStatusEnum.New,
	EngagementStatusEnum.InProgress,
	EngagementStatusEnum.Confirmed,
	EngagementStatusEnum.Completed,
];

export const EngagementStatusColorEnum = {
	[EngagementStatusEnum.New]: '#F8F282',
	[EngagementStatusEnum.InProgress]: '#93E9B3',
	[EngagementStatusEnum.Confirmed]: '#78BBE2',
	[EngagementStatusEnum.Completed]: '#F89377',
	[EngagementStatusEnum.Incomplete]: '#9D9D9D',
};
